<template>
  <main class="match-signup-page page-max-width">
      <MatchBackHomeButton />
    <MatchSignupEntrySection ref="entrySection" :entry-data="matchSignupEntryData" />
    <MatchSignupFlowSection :flow-data="matchSignupFlowData" />
    <MatchSignupInfoSection :info-data="matchSignupInfoData" />
    <MatchPageFooter />
  </main>
</template>

<script>
import MatchBackHomeButton from '@/components/match/common/MatchBackHomeButton.vue'
import MatchSignupEntrySection from '@/components/match/signup/MatchSignupEntrySection.vue'
import MatchSignupFlowSection from '@/components/match/signup/MatchSignupFlowSection.vue'
import MatchSignupInfoSection from '@/components/match/signup/MatchSignupInfoSection.vue'
import MatchPageFooter from '@/components/match/common/MatchPageFooter.vue'
import { matchSignupEntryData, matchSignupFlowData, matchSignupInfoData } from '@/data/match/matchSignup'

export default {
  name: 'MatchSignup',
  components: { MatchBackHomeButton, MatchSignupEntrySection, MatchSignupFlowSection, MatchSignupInfoSection, MatchPageFooter },
  data() {
    return { matchSignupEntryData, matchSignupFlowData, matchSignupInfoData }
  },
  mounted() {
    this.scrollToRouteAnchor()
  },
  watch: {
    '$route.query.anchor'() {
      this.scrollToRouteAnchor()
    },
  },
  methods: {
    scrollToRouteAnchor() {
      if (this.$route.query.anchor !== 'watch-address') return
      this.$nextTick(() => {
        window.requestAnimationFrame(() => {
          if (this.$refs.entrySection) this.$refs.entrySection.scrollToWatchTitle()
        })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.match-signup-page {
  position: relative;
  overflow-x: hidden;
  background: #f3f1ee url('@/assets/image/match/pc/match/signup-page-bg.jpg') center top / 100% auto no-repeat;
}

@media (max-width: 750px) {
  .match-signup-page {
    background: #ffffff url('@/assets/image/match/pc/match/signup-mobile-page-bg.png') center top / 100% auto no-repeat;
  }
}

</style>
